module.exports = __webpack_public_path__ + "static/media/probably_yes.0ac478a5.svg";